jQuery(document).ready(function($) {

  //Phone
  $( ".linkedin-phone" ).bind( "click", function() {
    window.lintrk('track', { conversion_id: 8010681 });
  });

  //Contact form main
  $( "#gform_submit_button_6" ).bind( "click", function() {
      window.lintrk('track', { conversion_id: 10057705 });
  });

 //Contact form apply
  $( "#gform_submit_button_5" ).bind( "click", function() {
      window.lintrk('track', { conversion_id: 10057705 });
  });

});